// extracted by mini-css-extract-plugin
module.exports = {"coach":"CoachCard_coach__2_pU_","coach__imgWrapper":"CoachCard_coach__imgWrapper__1NS1C"};